import { render, staticRenderFns } from "@/style-guide/partials/float-menu/float-menu.pug?vue&type=template&id=907802c0&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907802c0",
  null
  
)

export default component.exports